import formName from 'constants/formName'
import { actions, selectors } from 'data'
import { notifyError, notifySuccess } from 'data/App/sagas'
import { WhitelistAddressFormType } from 'data/types'
import isNil from 'lodash/isNil'
import { call, put, select } from 'redux-saga/effects'
import { removeWhitelistAddress } from 'services/api/payments'
import { Response } from 'utils/fetchApi'

export default function* listAddressesStep(form: WhitelistAddressFormType) {
  if (isNil(form.addressToDelete)) {
    yield call(notifyError, 'ko_payments_remove_whitelist', 'KO_GENERIC')
    return
  }

  const twoFactorStatus = yield select(selectors.auth.getTwoFactorStatus)
  const challenge = yield select(
    selectors.auth.secondFactorChallenge.getCurrentSecondFactorChallenge
  )
  // If 2FA was WALLET_SMS we need to send the challenge id we requested while
  // rendering the form
  const challengeId =
    twoFactorStatus && twoFactorStatus[0] === 'WALLET_SMS' ? challenge?.challengeId : undefined
  const data: Response<void> = yield call(removeWhitelistAddress, {
    challengeId,
    code: form.code || '',
    id: form.addressToDelete
  })

  if (!data.ok) {
    yield call(notifyError, data.error && data.error.cause, 'KO_GENERIC')
    yield put(actions.form.change(formName.WHITELIST_ADDRESS, 'loading', false))
    if (data.error && data.error.cause === 'Invalid 2FA') {
      yield put(actions.form.change(formName.WHITELIST_ADDRESS, 'code', ''))
    }
    return
  }

  yield put(actions.payments.fetchWhitelistAddresses())
  yield put(actions.form.change(formName.WHITELIST_ADDRESS, 'loading', false))
  yield call(notifySuccess, 'OK_WHITELIST_REMOVED')
}
